import { create } from 'zustand'

export type PublishTarget = 'all' | string[] | null

export const publishShiftIdsArg = (target: PublishTarget): string[] | undefined =>
  target === 'all' || target === null ? undefined : target

type ShiftsStore = {
  groupId: string
  setGroupId: (groupId: string) => void

  selectedShiftIds: Set<string>
  toggleShift: (id: string) => void
  setDaySelection: (ids: string[], selected: boolean) => void
  clearSelection: () => void
  reconcileSelection: (validIds: string[]) => void

  publishTarget: PublishTarget
  openPublish: (target: 'all' | string[]) => void
  closePublish: () => void

  deleteTarget: string[] | null
  openBulkDelete: (ids: string[]) => void
  closeBulkDelete: () => void
}

export const useShiftsStore = create<ShiftsStore>((set) => ({
  groupId: '',
  setGroupId: (groupId) =>
    set((state) =>
      state.groupId === groupId
        ? { groupId }
        : { groupId, selectedShiftIds: new Set(), publishTarget: null, deleteTarget: null }
    ),

  selectedShiftIds: new Set(),
  toggleShift: (id) =>
    set((state) => {
      const next = new Set(state.selectedShiftIds)
      if (next.has(id)) {
        next.delete(id)
      } else {
        next.add(id)
      }
      return { selectedShiftIds: next }
    }),
  setDaySelection: (ids, selected) =>
    set((state) => {
      const next = new Set(state.selectedShiftIds)
      ids.forEach((id) => (selected ? next.add(id) : next.delete(id)))
      return { selectedShiftIds: next }
    }),
  clearSelection: () => set({ selectedShiftIds: new Set() }),
  reconcileSelection: (validIds) =>
    set((state) => {
      const valid = new Set(validIds)
      const next = new Set([...state.selectedShiftIds].filter((id) => valid.has(id)))
      return next.size === state.selectedShiftIds.size ? {} : { selectedShiftIds: next }
    }),

  publishTarget: null,
  openPublish: (target) => set({ publishTarget: target }),
  closePublish: () => set({ publishTarget: null }),

  deleteTarget: null,
  openBulkDelete: (ids) => set({ deleteTarget: ids }),
  closeBulkDelete: () => set({ deleteTarget: null }),
}))
